import { WarrantyType } from "Store/interfaces/products/checkout/riskProducts/vehicleProducts/BaseVehicleProduct";

export enum VehicleInputType {
  MANUAL = "MANUAL",
  LICENSE_PLATE = "LICENSE_PLATE",
  OWNED = "OWNED",
}

export interface CarProductIntroFormValues {
  brand: string;
  canBeBoughtOnline: boolean;
  configurationId?: number;
  modelTypeName?: string;
  isAlreadyInsured?: boolean;
  kw: number;
  licensePlateNumber?: string;
  licensePlateNumberSearch?: string;
  licensePlateNumberSelected?: string;
  toggleVehicleInputType?: boolean;
  model: string;
  modelType?: string;
  tfaCode: string;
  vehicleInputType: VehicleInputType;
  volume: number;
  warrantyType?: WarrantyType;
  year: string;
}
